import { InfoPageLayout } from "../Layouts/InfoPageLayout";

export function AboutUs() {
  return (
      <InfoPageLayout>
          <div className="flex flex-col bg-gray-800 text-white">
              <div className="flex flex-col items-center justify-center pt-20">
                  <h1 className="header text-4xl text-white-400"><span className="text-gradient ">Who are we?</span></h1>
                  <h2 className="header text-2xl text-gray-600">Why choose us and what do we offer?</h2>
              </div>  
              <div className="flex flex-row pt-20">
                  <div className="grow min-w-[900px]"></div>
                  <div className="flex flex-col grow p-20  px-40">
                      <h1 className="header text-3xl" >Targeted Expertise</h1>
                      <h2 className="text-2xl ">
                          Alumni tutors are uniquely positioned to understand the exact syllabus, teaching style and assessment methods of the school.
                          This targeted knowledge ensures your child gets ahead with the most relevant academic support, saving time and effort.
                      </h2>
                  </div>
              </div>
              <div className="flex flex-row-reverse pt-20">

                  <div className="grow min-w-[900px]"></div>
                  <div className="flex flex-col grow p-20  px-40">
                      <h1 className="header text-3xl" >Personalised Support</h1>
                      <h2 className="text-2xl">
                          Because the tutors share a common educational background with your child, they can tailor their approach to suit the
                          specific challenges and opportunities presented by the school curriculum.
                      </h2>
                  </div>
              </div>
              <div className="flex flex-row pt-20">
                  <div className="grow min-w-[900px]"></div>
                  <div className="flex flex-col grow p-20  px-40">
                      <h1 className="header text-3xl " >Convenience</h1>
                      <h2 className="text-2xl">
                          All tutoring sessions are totally flexible around you and your child's schedule. Whether online or in person,
                          our advanced online system allows you to choose the times that work for you. Moreover, our automated billing makes it so you will never need to worry bank transfers or cash payments to our private tutors.
                      </h2>
                  </div>
              </div>
              <div className="flex flex-row-reverse pt-20">

                  <div className="grow min-w-[900px]"></div>
                  <div className="flex flex-col grow py-20 px-40">
                      <h1 className="header text-3xl" >Scheduling and Communication</h1>
                      <h2 className="text-2xl">
                          Our user-friendly website includes a seamless booking calendar and a secure messaging portal for direct communication with tutors.
                          Our responsive team is also always on hand to resolve scheduling issues or answer any questions. Managing your child's tutoring sessions has never been easier!
                      </h2>
                  </div>
              </div>
             
            
          </div>
    </InfoPageLayout>
  );
}